import { Component } from '@angular/core'
import { AgRendererComponent } from 'ag-grid-angular'
import { environment } from '@exchange/environment'

@Component({
  selector: 'app-episode-link-column-renderer',
  template: `
    <a *ngIf="!!params.data.PatientEpisodeId" [href]="url" target="_blank">{{
      params.data.PatientEpisodeId
    }}</a
    ><span></span>
  `,
  standalone: false
})
export class EpisodeLinkRendererComponent implements AgRendererComponent {
  public params: any
  public get url(): string {
    if (this.params && this.params.data && this.params.data.PatientEpisodeId) {
      return `${environment.pmroot}/episode/${this.params.data.PatientEpisodeId}/intake`
    }
    return 'javascript:void(0)'
  }

  agInit(params: any): void {
    this.params = params
  }

  refresh(params: any): boolean {
    return false
  }
}
